import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import Dashboard from "../pages/Dashboard";
import Alarmes from "../pages/Alarmes";
import Historico from "../pages/Historico";
import Relatorios from "../pages/Relatorios";
import Estatisticas from "../pages/Estatisticas";
import Inventario from "../pages/Inventario";
import Usuarios from "../pages/Usuarios";
import Assistencia from "../pages/Assistencia";
import Estudos from "../pages/Estudos";
import Login from "../pages/Login";
import Register from "../pages/Register";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import PrivateRoute from "./PrivateRoute";
import DashboardPage from "../pages/DashboardPage";
import IAMLPredicao from "../pages/IAMLPredicao";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Rotas protegidas */}
        <Route path="/" element={<PrivateRoute />}>
          <Route element={<MainLayout />}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="alarmes" element={<Alarmes />} />
            <Route path="historico" element={<Historico />} />
            <Route path="relatorios" element={<Relatorios />} />
            <Route path="estatisticas" element={<Estatisticas />} />
            <Route path="inventario" element={<Inventario />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="/ia" element={<IAMLPredicao />} />
            <Route path="assistencia" element={<Assistencia />} />
            <Route path="estudos" element={<Estudos />} />
            <Route index element={<Navigate to="dashboard" />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  );
}

